<template>
  <section id="hero" class="bg-landing relative z-auto overflow-hidden bg-cover bg-left-bottom bg-no-repeat">
    <div class="mx-auto flex min-h-screen w-full max-w-[85rem] flex-wrap items-center justify-center gap-10 px-4 pt-[80px]">
      <div class="grid w-full justify-items-center gap-4 md:w-auto lg:flex-1 lg:justify-items-start xl:pr-20">
        <h1 class="text-center font-exo-bold text-5xl text-balance uppercase lg:text-start lg:text-[72px]">
          Make
          <span class="bg-linear-to-r from-mauve-500 to-navy-blue-500 bg-clip-text text-transparent">Smarter Decisions</span> Now
        </h1>
        <p class="p-0 text-center text-lg text-pretty sm:px-20 md:px-0 lg:text-start lg:text-2xl">
          Assemble AI specialist teams that debate, challenge assumptions, and refine solutions together—delivering perspectives no single AI can
          provide.
        </p>
        <div class="relative grid w-fit items-start gap-3 lg:items-center">
          <UiButton
            v-if="!$page.props.auth.user"
            variant="gradient"
            size="lg"
            as-child
            class="px-10 text-xs text-nowrap uppercase hover:text-mauve-500 md:w-fit md:text-[16px]"
          >
            <a :href="route('register')"> Start my free trial </a>
          </UiButton>
          <p v-if="!$page.props.auth.user" class="text-sm text-eerie-black-200 italic">Includes 1,000 free credits to get you started.</p>
        </div>
      </div>

      <div class="w-full backdrop-blur-sm md:w-auto md:flex-1">
        <div class="mb-[90px] grid w-full lg:mb-0">
          <div
            class="w-full overflow-hidden rounded-3xl border border-mauve-500 shadow-[0px_0px_8px_0px] shadow-mauve-500 backdrop-blur-3xl transition-opacity"
          >
            <div class="relative aspect-video bg-transparent">
              <iframe
                class="h-full w-full border-0"
                src="https://www.youtube.com/embed/2MNZ6JUUjSU"
                title="Introducing VibeTeams: Your Guided Demo Experience"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerpolicy="strict-origin-when-cross-origin"
                width="500"
                height="250"
                allowfullscreen
                loading="lazy"
              ></iframe>
            </div>
          </div>
          <p class="mt-3 text-center text-sm text-eerie-black-200 italic">Quick tour — watch how it feels</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import { Button as UiButton } from '@/components/ui/button';
export default {
  components: {
    UiButton,
  },
};
</script>

<style scoped>
.bg-landing {
  background-image: url('@images/landing-page/landing-bg-asset.webp');
}
</style>
